import { SENSOR_STATES } from '@linearb/linjs-common';
import { PM_PROVIDERS } from 'common/constants/constants';
import { SENSOR_AUTH_TYPES } from 'common/services/sensors.service';

export const isSensorSupportScopesValidations = sensor => {
  const supportedSensors = [
    {
      sensorId: PM_PROVIDERS.JIRA,
      authType: SENSOR_AUTH_TYPES.OAUTH2,
      states: [
        SENSOR_STATES.inProgress,
        SENSOR_STATES['insufficient-permission'],
        SENSOR_STATES.ok
      ]
    }
  ];

  return supportedSensors.some(
    ({ sensorId, authType, states }) =>
      sensorId === sensor?.sensor_id &&
      authType === sensor?.profile?.auth_type &&
      states.includes(sensor?.state)
  );
};
